export const isBoolean = (value: any) => typeof value === 'boolean';

export const isNumber = (value: any) => typeof value === 'number';

export const isFloat = (value: any) => isNumber(value) && value % 1 !== 0;
